import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import * as React from 'react';

export function SvgCheck() {
  return <CheckMarkIcon label="" testId="ads-refreshed-icon" />;
}
